import h from 'react-hyperscript';

import PropTypes from 'prop-types';
import R from 'ramda';

import Grid from '../Grid';
import CourseListItem from '../CourseListItem';
import styles from './course-list.css';
import MissingCourse from '../MissingCourse';

const CourseList = ({
    courses,
    ...props
}) => {
    const sanitise = R.pipe(R.toLower);

    const isMatch = (query, course) => {
        if (R.isEmpty(query)) return false;
        const universityMatch = R.contains(sanitise(query), sanitise(course.university.name));
        const keywordMatch = R.contains(sanitise(query), sanitise(course.university.shortName || ''));

        return R.or(universityMatch, keywordMatch);
    };

    const matchingCourses = R.filter(R.curry(isMatch)(props.query), courses);

    if (R.gt(R.length(matchingCourses), 0)) {
        const list = matchingCourses.map((course, key) => h(CourseListItem, {key, course}));

        return h(Grid, {classNames: [styles.courseList]}, [list]);
    } else {
        return h(MissingCourse);
    }
};

CourseList.defaultProps = {
    query: '',
    courses: []
};

CourseList.propTypes = {
    query: PropTypes.string.isRequired
};

export default CourseList;



/** WEBPACK FOOTER **
 ** ./src/CourseList/index.js
 **/